import { fetchWithAuth } from './fetchWithAuth';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

// ==================== 마스터 ====================

export const getMentimeterList = async (menti_year) => {
  return fetchWithAuth(`/mentimeter?menti_year=${menti_year}`);
};

export const getMentimeter = async (menti_year, seq_no) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}`);
};

export const createMentimeter = async (body) => {
  return fetchWithAuth(`/mentimeter`, { method: 'POST', body: JSON.stringify(body) });
};

export const updateMentimeter = async (menti_year, seq_no, body) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}`, { method: 'PUT', body: JSON.stringify(body) });
};

export const deleteMentimeter = async (menti_year, seq_no) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}`, { method: 'DELETE' });
};

export const updateMentimeterStatus = async (menti_year, seq_no, status) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}/status`, {
    method: 'PATCH', body: JSON.stringify({ status }),
  });
};

export const updateCurrentQ = async (menti_year, seq_no, current_q_no) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}/current-q`, {
    method: 'PATCH', body: JSON.stringify({ current_q_no }),
  });
};

// ==================== 질문 ====================

export const getQuestions = async (menti_year, seq_no) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}/questions`);
};

export const saveQuestions = async (menti_year, seq_no, questions) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}/questions`, {
    method: 'POST', body: JSON.stringify({ questions }),
  });
};

// ==================== 결과 ====================

export const getMentimeterResult = async (menti_year, seq_no) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}/result`);
};

// ==================== 응답 (조합원, 로그인 불필요 — fetchWithAuth 미사용) ====================

export const getForResponse = async (branchCode, divisionCode, menti_year, seq_no) => {
  const res = await fetch(
    `${BASE_URL}/mentimeter/${menti_year}/${seq_no}/response?branch_code=${branchCode}&division_code=${divisionCode}`
  );
  return res.json();
};

export const submitAnswer = async (branchCode, divisionCode, menti_year, seq_no, answers) => {
  const res = await fetch(`${BASE_URL}/mentimeter/${menti_year}/${seq_no}/response`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ branch_code: branchCode, division_code: divisionCode, answers }),
  });
  if (!res.ok) {
    throw new Error(`서버 응답 오류 (${res.status})`);
  }
  return res.json();
};

export const copyMentimeter = async (menti_year, seq_no) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}/copy`, { method: 'POST' });
};

export const resetMentimeter = async (menti_year, seq_no) => {
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}/reset`, { method: 'POST' });
};

// ==================== 이미지 업로드 ====================
export const uploadMentiImage = async (menti_year, seq_no, file) => {
  const formData = new FormData();
  formData.append('image', file);
  return fetchWithAuth(`/mentimeter/${menti_year}/${seq_no}/upload-image`, {
    method: 'POST',
    body: formData,
  });
};